/**
 * 通知佇列的 React 包裝：狀態、TTL 掃除、逐條關閉。
 *
 * 放在 console-ui（props 驅動、不假設路由），所以 console 與 sugárgirl 兩頁可以共用同一個佇列；
 * 資料形狀與規則在 `../notices.ts`（純函式，node --test 直接測）。
 */
import { useCallback, useEffect, useMemo, useState } from 'react';
import { clearNoticesOfKind, dismissNotice as dismissFrom, pushNotice as pushTo, sweepNotices, } from '../notices';
export function useNotices() {
    const [notices, setNotices] = useState([]);
    /** 只有 sticky 之外的需要掃；有計時器才開 interval，閒著不燒 CPU。 */
    const hasTransient = useMemo(() => notices.some((item) => !item.sticky && item.kind !== 'error'), [notices]);
    useEffect(() => {
        if (!hasTransient)
            return;
        const timer = setInterval(() => {
            setNotices((prev) => {
                const next = sweepNotices(prev);
                return next.length === prev.length ? prev : next;
            });
        }, 1000);
        return () => clearInterval(timer);
    }, [hasTransient]);
    const push = useCallback((input) => {
        const now = Date.now();
        setNotices((prev) => pushTo(prev, input, now));
    }, []);
    const notify = useCallback((kind, message, extra) => {
        push({ kind, message, ...extra });
    }, [push]);
    const dismiss = useCallback((id) => {
        setNotices((prev) => dismissFrom(prev, id));
    }, []);
    const clearKind = useCallback((kind) => {
        setNotices((prev) => {
            const next = clearNoticesOfKind(prev, kind);
            return next.length === prev.length ? prev : next;
        });
    }, []);
    const clearAll = useCallback(() => setNotices([]), []);
    return {
        notices,
        hasError: notices.some((item) => item.kind === 'error'),
        push,
        notify,
        dismiss,
        clearKind,
        clearAll,
    };
}
//# sourceMappingURL=useNotices.js.map